import React from "react";
import { useController } from "react-hook-form";
import { i18n } from "@/i18n";
import { InputWrapper } from "@/components/FormInputs/InputWrapper";
import { YesNoEnum } from "@/__generated__/graphql";
import { RadioGroup, RadioGroupItem } from "@/components/ui/RadioGroup";
import { FormValues } from "../types";

interface FirstTimeMessageRecipientInputProps {
  disabled: boolean;
}

export function FirstTimeMessageRecipientInput({
  disabled = false,
}: FirstTimeMessageRecipientInputProps) {
  const { field, formState } = useController<FormValues>({
    name: "filters.firstTimeMessageRecipients",
  });

  return (
    <InputWrapper
      name="filters.firstTimeMessageRecipients"
      label={i18n.t(
        "bulkMessaging.basicInformation.inputs.firstTimeMessageRecipients.label",
      )}
      className="gap-4"
      error={formState.errors?.filters?.firstTimeMessageRecipients}
    >
      <RadioGroup
        defaultValue={field.value as YesNoEnum}
        onValueChange={field.onChange}
        className="flex gap-8"
        disabled={disabled}
      >
        <div className="flex items-center gap-2">
          <RadioGroupItem
            disabled={disabled}
            value={YesNoEnum.Yes}
            id="first-time-message-recipients-yes"
            data-testid="first-time-yes"
          />
          <label
            htmlFor="first-time-message-recipients-yes"
            className="flex items-center gap-1 font-medium text-foreground"
          >
            {i18n.t("global.yes")}
          </label>
        </div>
        <div className="flex items-center gap-2">
          <RadioGroupItem
            disabled={disabled}
            value={YesNoEnum.No}
            id="first-time-message-recipients-no"
            data-testid="first-time-no"
          />
          <label
            htmlFor="first-time-message-recipients-no"
            className="flex items-center gap-1 font-medium text-foreground"
          >
            {i18n.t("global.no")}
          </label>
        </div>
      </RadioGroup>
      <small className="w-80 text-sm text-muted-foreground">
        {recipientTypeDisplay(field.value as YesNoEnum)}
      </small>
    </InputWrapper>
  );
}

function recipientTypeDisplay(recipientType?: string) {
  if (recipientType === YesNoEnum.Yes) {
    return i18n.t(
      "bulkMessaging.basicInformation.inputs.firstTimeMessageRecipients.placeholderYes",
    );
  } else if (recipientType === YesNoEnum.No) {
    return i18n.t(
      "bulkMessaging.basicInformation.inputs.firstTimeMessageRecipients.placeholderNo",
    );
  }
}
